export const SET_NOTIFICATIONS = "SET_NOTIFICATIONS";
export const SET_TOTAL_NOTIFICATIONS = "SET_TOTAL_NOTIFICATIONS";
